import React, { useEffect, useState } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Page from 'components/Page';
import { Header } from 'components';
import serviciosCatalogo from 'utils/serviciosCatalogo'
import CuerpoCatalogo from './Components/CuerpoCatalogo';
import Formulario from './Components/FormularioGrupo';
import getErrorMessage from 'utils/getErrorMessage';
import { useForm } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3), 
    paddingTop: theme.spacing(3)
  },
}));

const Grupo = ({permisos}) => {
  const classes = useStyles();
  const {register,errors,handleSubmit}=useForm();

  const [data,setData]=useState([]);
  const [cargando,setCargando]=useState(false);
  const [mensaje,setMensaje]=useState({open:false});
  const [modal,setModal]=useState({open:false});
  const [mAdvertencia,setMAdvertencia]=useState({open:false});

  const servicios={
    get:()=>serviciosCatalogo.gruposAll(setData,setCargando),
    insert:(data)=>serviciosCatalogo.gruposCreate(respuesta(cerrarModal),setCargando,data),
    update:(data)=>serviciosCatalogo.gruposUpdate(respuesta(cerrarModal),setCargando,data),
    baja:(data)=>serviciosCatalogo.gruposDown(respuesta(()=>{}),setCargando,data)
  }

  const cerrarModal=()=>setModal({open:false});
  const cerrarAdvertencia=()=>setMAdvertencia({open:false});
  
  const respuesta=onSuccess=>(status,mensaje,data)=>{
    if(status>0){
      onSuccess();
      setData(data)
    }
    setMensaje({open:true,status:status,value:mensaje});
    cerrarAdvertencia();
  }
  const cerrarMensaje=()=>setMensaje({...mensaje,open:false});
  const columns=[
    {label:'GRUPO',name:"ngrupo",filtrar:true},
    {label:'ESTATUS',name:"nombreEstatus",filtrar:false}
  ]

  useEffect(()=>{
    servicios.get(setData,setCargando);
  },[])
  return (
    <Page
      className={classes.root}
      title="GRUPO"
      mensaje={{...mensaje,cerrar:cerrarMensaje}}
      cargando={cargando}
    >
      <Container maxWidth={false}>
        <Header title="CATÁLOGO" subtitle="GRUPO"/>
        <CuerpoCatalogo
          keyTabla='catGrupo'
          servicios={servicios}
          columns={columns}
          data={data}
          permisos={permisos}
          id='idgrupo'
          catalogo='grupo'
          modal={modal}
          setModal={setModal}
          mAdvertencia={mAdvertencia}
          setMAdvertencia={setMAdvertencia}
          handleSubmit={handleSubmit}
          form={<Formulario 
            register={register} 
            errors={getErrorMessage(errors)}
            defaultItem={modal.item||{}}
          />}
        />
      </Container>  
    </Page>
  );
};

export default Grupo;